import { NJIconButton } from "@engie-group/fluid-design-system-react";
import { useNavigate } from "react-router-dom";

/** Back-navigation control shown at the top of every detail/form page. */
export function BackButton({ to, label }: { to: string; label: string }) {
  const navigate = useNavigate();
  return (
    <div className="flex justify-start">
      <NJIconButton
        icon="arrow_back"
        variant="tertiary"
        label={label}
        onClick={() => navigate(to)}
      />
    </div>
  );
}
